/* eslint-disable no-shadow */
import moment from 'moment';

import JsPDF from 'jspdf';
import html2canvas from 'html2canvas';

export const hasAssetBuy = hasSpot => (
  hasSpot ? 'com a compra da ação' : 'sem a compra da ação'
);

export const oneYear = () => moment('20220331');

export const getKeyByValue = (object, value) => Object.keys(object).find(key => object[key] === value);

export const toCapitalizeCase = (value) => {
  if (value) {
    const newValue = value?.toLowerCase();
    return newValue.charAt(0).toUpperCase() + newValue.slice(1);
  }
  return value;
};

export const getApplicationStorage = () => {
  const storage = localStorage.getItem('cotizador-storage');
  return storage ? JSON.parse(storage) : {};
};

export const setApplicationStorage = (data) => {
  localStorage.setItem('cotizador-storage', JSON.stringify(data));
};

export const objHasProp = (obj, prop) => (
  Object.prototype.hasOwnProperty.call(obj, prop)
);

export const removeMask = (value) => {
  const onlyNumbers = value.toString().match(/[\d]|[,]/gi);
  const numbers = onlyNumbers ? Number(onlyNumbers.join('').replace(',', '.')) : value;

  return numbers;
};

export const maskMoney = (value) => {
  let newValue = '';

  if (typeof value === 'number') {
    const integerPart = Math.floor(value);
    const decimalPart = Math.floor((value - integerPart) * 100) / 100;
    newValue = `${integerPart}${decimalPart.toString().padStart(2, '0')}`;
  } else {
    newValue = value.toString().replace(/\D/g, '');
  }

  newValue = newValue.replace(/^0+/, '');
  newValue = newValue.substring(0, 14); // max 999.999.999.999,00
  while (newValue.length < 3 && newValue.length > 0) {
    newValue = `0${newValue}`;
  }

  let nextStep = 2;
  let nextSeparator = ',';
  while (newValue.length > nextStep) {
    const separatorPosition = newValue.length - nextStep;
    newValue = newValue.slice(0, separatorPosition) + nextSeparator + newValue.slice(separatorPosition);
    nextStep += 4;
    nextSeparator = '.';
  }

  return newValue ? `R$ ${newValue}` : '';
};

export const pad = time => (time.toString().padStart(2, '0'));

export const convertDateTime = (timestamp, fullYear = false) => {
  const date = new Date(timestamp);
  const d = pad(date.getDate());
  const m = pad(date.getMonth() + 1);
  let y = pad(date.getFullYear()).toString();
  y = fullYear ? y : y.slice(2, 4);
  const h = date.getHours();
  const mn = pad(date.getMinutes());

  return `${d}/${m}/${y} às ${h}:${mn}`;
};

export const dateTimeNow = () => {
  const date = new Date();
  const d = pad(date.getDate());
  const m = pad(date.getMonth() + 1);
  const y = pad(date.getFullYear());
  const h = date.getHours();
  const mn = pad(date.getMinutes());

  return `${h}:${mn} de ${d}/${m}/${y} `;
};

const getDateNumbers = (timestamp) => {
  const date = new Date(timestamp);
  const d = pad(date.getDate());
  const m = pad(date.getMonth() + 1);
  const y = pad(date.getFullYear());

  return {
    d,
    m,
    y,
  };
};

export const convertDate = (timestamp) => {
  const date = getDateNumbers(timestamp);

  return `${date.d}/${date.m}/${date.y}`;
};

export const getEnglishDateFormat = date => (
  `${date.y}-${date.m}-${date.d}`
);

export const convertEnglishDate = (timestamp) => {
  const date = getDateNumbers(timestamp);

  return getEnglishDateFormat(date);
};

export const getToday = () => {
  const today = moment();
  const date = getDateNumbers(today);

  return getEnglishDateFormat(date);
};

const today = moment();
export const isOutsideRange = date => date.day() === 6 || date.day() === 0 || today._d >= date._d;

export const disableDayBiggerOndeYear = date => isOutsideRange(date) || date.isAfter(moment().add(366, 'days'));

const afterdays = months => moment().add(months, 'M');

export const isDayBlocked = (date, holidays) => {
  const today = moment();
  const wenesday = 3;
  const firstDay = 1;
  const secondDay = 2;
  const lastDay = date.daysInMonth();
  const penultimateDay = date.daysInMonth() - 1;
  const dateOfMonth = date.date();
  const dateOfWeek = date.day();

  return !(dateOfWeek === wenesday)
    || (holidays.includes(date.toISOString().split('T')[0]))
    || (dateOfMonth === firstDay)
    || (dateOfMonth === secondDay)
    || (dateOfMonth === lastDay)
    || (dateOfMonth === penultimateDay)
    || date <= afterdays(2)
    || date >= afterdays(7)
    || date < today;
};

export const convertToCurrency = (number, currency = 'BRL', fractionDigits = 2) => {
  const stringValue = parseFloat(number).toLocaleString('pt-BR', {
    style: 'currency',
    currency,
    minimumFractionDigits: fractionDigits,
  });

  return stringValue;
};

export const converToNumber = (string) => {
  if (string) {
    return parseFloat(string.replace(/\./g, '').replace(',', '.'));
  }
  return string;
};

export const truncate = value => Math.trunc(value * 100) / 100;

export const convertNumberBR = (number, decimal) => {
  if (number) {
    return parseFloat(number).toLocaleString('pt-BR', { minimumFractionDigits: decimal || 0 });
  }
  return number;
};

export const toFixed = (num, fixed) => {
  const re = new RegExp(`^-?\\d+(?:.\\d{0, ${(fixed || -1)} })?`);
  return num.toString().match(re)[0];
};

export const convertPercentage = number => (
  `${convertNumberBR(number)}%`
);

export const blockScroll = () => (
  window.document.querySelector('body').classList.add('block-scroll')
);

export const unblockScroll = () => (
  window.document.querySelector('body').classList.remove('block-scroll')
);

const NEUTRAL = 'neutral';
const POSITIVE = 'positive';

export const getStructureStatusColor = (title) => {
  const strategies = [
    {
      key: POSITIVE,
      color: '#5BB26B',
      keywords: ['acima', 'ganho', 'alta'],
    },
    {
      key: NEUTRAL,
      color: '#388584',
      keywords: ['entre', 'proteção'],
    },
  ];

  const selectedStatus = strategies.find(strategy => (
    strategy.keywords.some(keyword => title?.toLowerCase().includes(keyword))
  ));

  return selectedStatus ? selectedStatus.color : '#D27814';
};

export const convertPDF = (response, pdfName, beforeBack, afterBack) => {
  if (beforeBack) {
    beforeBack();
  }
  
  setTimeout(() => {
    html2canvas(document.querySelector('#push-content'), {
      imageTimeout: 2000,
      logging: true,
    }).then((canvas) => {
      const image = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream');

      const pdfSize = {
        width: document.querySelector('#push-content').clientWidth,
        height: document.querySelector('#push-content').clientHeight,
      };

      const pdf = new JsPDF({
        orientation: 'p', // landscape
        unit: 'pt', // points, pixels won't work properly
        format: [pdfSize.width, pdfSize.height], // set needed dimensions for any element
      });

      pdf.addImage(image, 'PNG', 0, 0, pdfSize.width, pdfSize.height);
      return pdf.output('blob');
    }).then(async (output) => {
      await saveAs(output, `${pdfName}.pdf`);
      
      if (afterBack) {
        afterBack();
      }
    });
  }, 10);
};

export const toMaskNumber = (value) => {
  let newValue = '';

  if (typeof value === 'number') {
    const integerPart = Math.floor(value);
    const decimalPart = Math.floor((value - integerPart) * 100) / 100;
    newValue = `${integerPart}${decimalPart.toString().padStart(2, '0')}`;
  } else {
    newValue = value.toString().replace(/\D/g, '');
  }

  newValue = newValue.replace(/^0+/, '');
  newValue = newValue.substring(0, 14); // max 999.999.999.999,00
  while (newValue.length < 3 && newValue.length > 0) {
    newValue = `0${newValue}`;
  }

  let nextStep = 2;
  let nextSeparator = ',';
  while (newValue.length > nextStep) {
    const separatorPosition = newValue.length - nextStep;
    newValue = newValue.slice(0, separatorPosition) + nextSeparator + newValue.slice(separatorPosition);
    nextStep += 4;
    nextSeparator = '.';
  }

  return newValue === '' ? '0,00' : newValue;
};

export const maskPercentage = (value) => {
  let newValue = value.replace(/[A-Za-z]|[ +]|%|!|@|#|%|ˆ|&|\*|\(|\)|\+|=/g, '');

  const hasMask = Boolean(value.match(' %'));
  const hasNumber = Boolean(value.match(/\d|-/));

  if (hasNumber) {
    let indexCharsToRemove = newValue.length;

    if (newValue.length > 1) {
      indexCharsToRemove -= hasMask ? 0 : 1;
    }

    newValue = newValue.slice(0, indexCharsToRemove);
    newValue = newValue.match(/\d|-/)?.length > 0 ? newValue : '0';

    return `${newValue.trim()} %`;
  }

  return '0 %';
};

export const removeMaskPercentage = value => (
  typeof value === 'number'
    ? value
    : Number(value.replace(/%/g, '').replace(/\./g, '').replace(',', '.').replace(/\s/g, '')
      .trim())
);

export const groupByDate = (array) => {
  if (array.length > 0) {
    const groups = array.reduce((acc, item) => {
      const date = new Date(item.creationDateTime);
      const today = new Date();
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);

      if (item.action && !Array.isArray(item.action)) {
        // eslint-disable-next-line no-param-reassign
        item.action = [item.action];
      }

      if (date.toDateString() === today.toDateString()) {
        acc.today.items.push(item);
      } else if (date.toDateString() === yesterday.toDateString()) {
        acc.yesterday.items.push(item);
      } else {
        acc.oldest.items.push(item);
      }

      return acc;
    }, {
      today: {
        name: 'Hoje',
        items: [],
      },
      yesterday: {
        name: 'Ontem',
        items: [],
      },
      oldest: {
        name: 'Mais antigos',
        items: [],
      },
    });

    return groups;
  }
  return {};
};

export const moneyFormatter = (value, currency = 'BRL', prefix = 'R$') => {
  let formatted = '';
  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  // caractere especial non-braking space /xa0
  // https://stackoverflow.com/questions/54242039/intl-numberformat-space-character-does-not-match
  formatted = formatter.format(value).replace('\xa0', ' ');

  if (value < 0) formatted = formatted.replace('-R$ ', 'R$ -');

  formatted = formatted.replace('R$', prefix);

  return formatted;
};
